export type FetchParams = Parameters<typeof fetch>;

export enum InternalJiraEndpoints {
    JIRA_PERMISSIONS = "/rest/api/3/mypermissions",
    JIRA_INVITE_USER = "/rest/internal/latest/invite-user/request-access/project",
    JIRA_INVITE_USER_FALLBACK = "/gateway/api/invitations/invite"
}

export const InterceptPaths = [
    InternalJiraEndpoints.JIRA_PERMISSIONS,
    InternalJiraEndpoints.JIRA_INVITE_USER,
    InternalJiraEndpoints.JIRA_INVITE_USER_FALLBACK
];

export type Jfind1663FetchInterceptorParams = {
    cloudId: string;
};

export const TENANT_AWARE_REDIRECT = "/gateway/api/ex/jira/$cloudId";

export type Fetched<T> = T | null | undefined;
